import {AfterViewInit, Component, Input, OnInit, Pipe, PipeTransform} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AppService} from '../../../services/app.service';
import * as $ from 'jquery';
import {AnalyticsService} from '../../../services/analytics.service';

declare var UIkit: any;

@Pipe({name: 'slugify'})
export class SlugifyPipe implements PipeTransform {
  transform(input: string): string {
    return input.toString().toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text
  }
}

@Component({
  selector: 'app-standard-product',
  templateUrl: './standard-product.component.html',
  styleUrls: ['./standard-product.component.css']
})
export class StandardProductComponent implements OnInit {
  product: any;
  pageURL;
  pageFeaturedImage;
  productDeals: any;
  nonVegCheckBox = false;
  vegCheckBox = false;

  public pageSlug;
  public pageCity;

  selectedExperience: any;
  selectedDeal: any;

  productGalleryFirstImage = [];
  productVisibleImages = [];
  productHiddenImages = [];

  @Input()
  get productData(): string {
    return this.product;
  }

  set productData(product: any) {
    this.product = product;

    this.productVisibleImages = Object.assign([], this.product.product_images);
    this.productHiddenImages = Object.assign([], this.product.product_images);
    this.productGalleryFirstImage = Object.assign([], this.product.product_images);
    this.productDeals = Object.assign([], this.product.products_standard_deals);

    this.productVisibleImages = this.productVisibleImages.slice(0, 5);
    this.productHiddenImages = this.productHiddenImages.slice(5);
    this.productGalleryFirstImage = this.productGalleryFirstImage.slice(0, 1);

    // set the featured image for social sharing
    this.product.product_images.forEach(element => {
      this.pageFeaturedImage = element.images;
    });

    this.analyticService.pageImpression(this.product);

    // default deal selection
    this.selectedExperience = product;

    const firstStockedDeal = this.productDeals.filter(item => item.deal_stock > 0);
    this.selectedDeal = firstStockedDeal[0];


    // change to numeric for calculations
    this.selectedDeal.quantity = 1;
    if (this.selectedDeal.deal_regular_price === NaN) {
      this.selectedDeal.deal_regular_price = Number(this.selectedDeal.deal_regular_price?.replace(/[^0-9.-]+/g, ''));
    }
    if (this.selectedDeal.deal_sale_price === NaN) {
      this.selectedDeal.deal_sale_price = Number(this.selectedDeal.deal_sale_price?.replace(/[^0-9.-]+/g, ''));
    }

    this.selectedDeal.quantity = 1;

    // page URL for social sharing
    this.pageURL = 'https://things2.do' + this.router.url;
    setTimeout(res => {
      var first = $('.gallery-item.item-left a:nth-child(2)').innerHeight();
      $('.gallery-item.item-left a:nth-child(1)').css({'height': first + first + 12});

      $('.gallery-item a').each(function(index) {
        var matched = $('.gallery-item a');
        var matchedLength = matched.length - 1;
        //console.log( index + 1);
        $(this).attr('data-caption', index + 1 + ' / ' + matchedLength);
      });

    }, 600);

  }

  constructor(
    private router: Router,
    public appService: AppService,
    private analyticService: AnalyticsService,
    private activatedRoute: ActivatedRoute,
  ) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.pageSlug = params.slug;
      this.pageCity = params.city;
    });
  }

  openShareLink(): void {
    $('.sharelink').slideToggle();
  }

  increaseQty(selectedDeal): void {
    if (selectedDeal.deal_limited === 1) {
      this.selectedDeal.quantity = 1;
      return;
    }

    if (selectedDeal.deal_id !== this.selectedDeal.deal_id) {
      this.selectedDeal.quantity = 1;
    }

    if (selectedDeal.deal_stock > 0) {
      this.selectedDeal = selectedDeal;
      if (this.selectedDeal.quantity < this.selectedDeal.deal_stock && this.selectedDeal.quantity < 30) {
        this.selectedDeal.quantity++;
      }
    }
  }

  decreaseQty(selectedDeal): void {

    if (selectedDeal.deal_limited === 1) {
      this.selectedDeal.quantity = 1;
      return;
    }

    if (selectedDeal.deal_id !== this.selectedDeal.deal_id) {
      this.selectedDeal.quantity = 1;
    }

    if (selectedDeal.deal_stock > 0) {
      this.selectedDeal = selectedDeal;
      if (this.selectedDeal.quantity > 1) {
        this.selectedDeal.quantity--;
      }
    }
  }

  openSlideShow(): void {
    UIkit.lightbox('.mob-sli').show();
  }

  onVegSelectChange(e): void {

    this.selectedDeal = '';

    if (e.checked) {
      this.nonVegCheckBox = false;
      this.productDeals = this.product.products_standard_deals.filter(p => p.deal_veg === true);
      const firstStockedDeal = this.productDeals.filter(item => item.deal_stock > 0);
      this.selectedDeal = firstStockedDeal[0];
    } else {
      this.productDeals = Object.assign([], this.product.products_standard_deals);
      const firstStockedDeal = this.productDeals.filter(item => item.deal_stock > 0);
      this.selectedDeal = firstStockedDeal[0];
    }
  }

  onNonVegSelectChange(e): void {
    this.selectedDeal = '';
    if (e.checked) {
      this.vegCheckBox = false;
      this.productDeals = this.product.products_standard_deals.filter(p => p.deal_non_veg === true);
      const firstStockedDeal = this.productDeals.filter(item => item.deal_stock > 0);
      this.selectedDeal = firstStockedDeal[0];
    } else {
      this.productDeals = Object.assign([], this.product.products_standard_deals);
      const firstStockedDeal = this.productDeals.filter(item => item.deal_stock > 0);
      this.selectedDeal = firstStockedDeal[0];
    }
  }

  selectExperience(product, deal): void {
    this.selectedDeal.quantity = 1;


    this.selectedExperience = product;
    this.selectedExperience.selected = true;
    this.selectedDeal = deal;
    this.selectedDeal.quantity = 1;
    if (this.selectedDeal.deal_regular_price) {
      this.selectedDeal.deal_regular_price = Number(this.selectedDeal.deal_regular_price?.replace(/[^0-9.-]+/g, ''));
    }

    if (this.selectedDeal.deal_sale_price) {
      this.selectedDeal.deal_sale_price = Number(this.selectedDeal.deal_sale_price?.replace(/[^0-9.-]+/g, ''));
    }

  }

  addToWishlist(e): void {
    let w = $(e).attr('class');
    (w == 'fa fa-bookmark-o') ? $(e).attr('class', 'fa fa-bookmark') : $(e).attr('class', 'fa fa-bookmark-o');
    if (w == 'fa fa-bookmark-o') {
      // add to wishlist
      this.appService.addToWishlist(this.product.id);
    } else {
      // remove from wishlist
      this.appService.removeFromWishlist(this.product.id);
    }
  }

  /**
   * Add this product to the cart
   */
  addToCart(): void {
    // add to cart
    this.analyticService.addToCart(this.selectedExperience, this.selectedDeal);
    localStorage.setItem('product', JSON.stringify(this.selectedExperience));
    localStorage.setItem('deal', JSON.stringify(this.selectedDeal));
    this.router.navigate(['/order-summary']);
  }

}
